<template>
  <Layout class="g-wrapper g-vertical-block">
    <div class="c-robot g-main-wrapper">
      <!-- filter -->
      <robot-filter
        placeholder="请输入文案ID或者名称"
        :game-data="gameData"
        :agent-data="agentData"
        :project-group-data="projectGroupData"
        :media-data="mediaData"
        :middle-game-data="middleGameData"
        @on-down="downData"
        @on-change="filterData"
      />
      <!-- table -->
      <div class="c-table-list">
        <Viewport v-model="tableHeight">
          <robot-table
            :height="tableHeight"
            :loading="loading"
            :data="tableList"
            :columns="tableCol"
            :summary="sumData"
            @on-sort="sortTable"
          />
          <Page
            show-total
            show-sizer
            show-elevator
            :total="total"
            :current.sync="pageIndex"
            :page-size="pageSize"
            :page-size-opts="[10, 20, 30, 40, 100]"
            @on-change="changePageIndex"
            @on-page-size-change="changePageSize"
            class="c-table-page"
            size="small"
          />
        </Viewport>
      </div>
    </div>
  </Layout>
</template>
<script>
import mixin from '../mixins/mixin'
import columns from '../data/robot_column'
import { HOST_API } from '@/api/config'
import { setLocal, getLocal } from '@/common/js/api'
import { isArray } from '@/common/js/utils'
import { getPlanDataPage } from '@/api/team.model'
import { adGames, getSysMember, getSysProject, getSysMedia, getMiddleGameList } from '@/api/common.model'
import RobotFilter from './components/robot-filter'
import RobotTable from './components/robot-table'

export default {
  name: 'robotdata',
  mixins: [mixin],
  components: { RobotFilter, RobotTable },
  methods: {
    getData(filter) {
      let params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        sort: this.sort,
        order: this.order
      }
      if (filter) params = Object.assign(params, filter)
      else params = Object.assign(this.params, params)
      this.params = JSON.parse(JSON.stringify(params))
      // 加载状态
      this.loading = true
      getPlanDataPage(params)
        .then((data) => {
          this.loading = false
          if (!data) return
          const { list, page_info, sum_data } = data
          if (isArray(list) && page_info && sum_data) {
            const { total_number } = page_info
            this.sumData = sum_data
            this.total = total_number || 0
            this.tableList = list
          }
        })
        .catch((err) => {
          this.$Message.error({
            duration: 5,
            content: err
          })
        })
    },
    setLocalPage(size) {
      setLocal('ROBOTDATA_PAGESIZE', size)
    },
    downData() {
      let url = `${HOST_API}/api/ptom/AI/PlanDataExport`
      url += `?sessionid=${this.$store.state.token}`
      url += `&reportMonth=${this.params.reportMonth}`
      this.params.gameIdStr && (url += `&gameIdStr=${this.params.gameIdStr}`)
      this.params.mediaIdStr && (url += `&mediaIdStr=${this.params.mediaIdStr}`)
      this.params.midGameIdsStr && (url += `&midGameIdsStr=${this.params.midGameIdsStr}`)
      this.params.projectGroupOpIds && (url += `&projectGroupOpIds=${this.params.projectGroupOpIds}`)
      this.params.opIdsStr && (url += `&opIdsStr=${this.params.opIdsStr}`)
      this.params.platformStr && (url += `&platformStr=${this.params.platformStr}`)
      this.params.order && (url += `&order=${this.params.order}`)
      this.params.sort && (url += `&sort=${this.params.sort}`)
      window.open(url)
    },
    sortTable(params) {
      const { sort, order } = params
      this.sort = sort
      this.order = order
      this.pageIndex = 1
      this.getData()
    },
    preloadData() {
      Promise.all([adGames(), getSysMember(), getSysProject(), getSysMedia(), getMiddleGameList()])
        .then((data) => {
          const [game, agentData, projectGroupData, mediaData, middleGameData] = data
          isArray(game) && (this.gameData = game)
          isArray(agentData) && (this.agentData = agentData)
          isArray(projectGroupData) && (this.projectGroupData = projectGroupData)
          isArray(mediaData) && (this.mediaData = mediaData)
          isArray(middleGameData) && (this.middleGameData = middleGameData)
        })
        .catch((err) => {
          console.log(err)
        })
    }
  },
  data() {
    return {
      tableHeight: 330,
      model: false, // 弹窗开关
      gameData: [],
      agentData: [],
      projectGroupData: [],
      mediaData: [],
      middleGameData: [],
      sumData: {}
    }
  },
  created() {
    this.pageSize = parseInt(getLocal('ROBOTDATA_PAGESIZE')) || 20
    this.tableCol = columns
    this.preloadData()
  }
}
</script>
<style lang="scss" scoped>
.c-robot {
  padding: 8px 8px 0;
}

.c-table-page {
  padding: 5px 0;
  text-align: right;
}
</style>
